<template>
  <div>
    <!-- Navigation -->
    <nav
      role="navigation"
      class="fixed top-0 z-40 flex w-full bg-brand-500 xl:hidden"
    >
      <div class="flex-1 px-5 py-3 pt-4">
        <a
          href="/"
          class="inline-block outline-none"
        >
          <LogoItem />
        </a>
      </div>

      <v-burger
        type="collapse"
        :active="menuOpen"
        @updated="toggleMenu"
      />
    </nav>

    <!-- Menu -->
    <transition
      enter-active-class="transition-all duration-500 ease-in-out"
      leave-active-class="transition-all duration-500 ease-in-out"
      enter-class="transform -translate-y-full opacity-0"
      enter-to-class="transform translate-y-0 opacity-100"
      leave-class="transform translate-y-0 opacity-100"
      leave-to-class="transform -translate-y-full opacity-0"
    >
      <div
        v-if="menuOpen"
        class="fixed top-0 z-30 flex flex-col w-full h-screen px-10 pb-32 overflow-hidden text-white pt-28 bg-brand-500 xl:hidden"
      >
        <div class="flex-1">
          <ul
            class="flex flex-col justify-between h-full text-xl tracking-wider uppercase max-h-menu"
          >
            <li
              v-for="(item, index) in navigationData.menu"
              :key="index"
            >
              <a
                :href="item.url"
                class="btn-link"
              >{{ item.title }}</a>
            </li>
            <li class="mt-2">
              <a
                :href="navigationData.cta.url"
                class="inline-block text-center outline-none btn btn-danger"
              >{{ navigationData.cta.label }}</a>
            </li>
          </ul>
          <ul class="flex mt-5 space-x-5">
            <li>
              <a
                :href="navigationData.languages.fr"
                class="btn-link is-line is-thick"
              >FR</a>
            </li>
            <li>
              <a
                :href="navigationData.languages.nl"
                class="btn-link is-line is-thick"
              >NL</a>
            </li>
          </ul>
        </div>

        <div
          v-if="navigationData.enable_badge"
          class="pt-20"
        >
          <img
            class="h-20"
            :src="navigationData.badge"
          >
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { VBurger } from "vue-burger";
import LogoItem from "./LogoItem.vue";

export default {
  components: {
    LogoItem,
    VBurger,
  },
  data() {
    return {
      menuOpen: false,
      navigationData: window.navigationData,
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      if (this.menuOpen) {
        document
          .querySelector("body")
          .classList.add("overflow-hidden", "h-screen");
      } else {
        document
          .querySelector("body")
          .classList.remove("overflow-hidden", "h-screen");
      }
    },
  },
};
</script>

<style>
.hamburger,
.hamburger:focus {
  @apply bg-brand-500 px-4 py-4 !important;
}

.hamburger:hover {
  @apply bg-brand-600 !important;
}

.hamburger-box {
  @apply w-10 h-7 !important;
}

.hamburger-inner:after {
  @apply hidden !important;
}

.hamburger-inner,
.hamburger-inner:before {
  height: 2px !important;
  @apply bg-white rounded-none w-10 !important;
}

.hamburger-inner {
  @apply top-6;
}

.hamburger-inner:before {
  @apply -top-4 !important;
}

.hamburger.is-active .hamburger-inner:before {
  @apply -top-px !important;
}
</style>
